import React from "react"

import DownloadLink from "./download-link"

const IDENTITY_VERIFICATION_DEEPLINK = "https://a.nelo.mx/ZpywgahKiMb"

const VerifyInWhatsappScreen = () => {
  return (
    <div className="flex h-screen w-full flex-col">
      <div className="grow overflow-y-auto px-8 pb-10 pt-32">
        <h1 className="mb-4 text-4xl font-bold text-nelo-blue">Completa tu verificación en WhatsApp</h1>
        <p className="mb-8 text-ui-fg-base">Tu pedido se completará una vez que completes tu verificación.</p>
        <div className="relative overflow-hidden rounded-lg bg-gradient-to-br from-nelo-blue via-blue-200 via-blue-300 via-blue-400 to-nelo-blue p-8 shadow-lg">
          <div className="relative z-10">
            <h2 className="mb-4 text-2xl font-bold text-white">¡Usa tu crédito Nelo dentro de la app!</h2>
            <p className="mb-8 text-white">
              Compra en línea, retira efectivo, paga tus servicios y realiza recargas. Todo a quincenas desde un mismo lugar.
            </p>
            <div className="flex justify-center px-4">
              <DownloadLink deeplinkUrl={IDENTITY_VERIFICATION_DEEPLINK} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default VerifyInWhatsappScreen
